import {
  RemoteGetNumberStudentsPerProfessionalInField,
  RemoteExportNumberStudentsPerProfessionalInField,
} from 'data/usecases';
import {
  GetNumberStudentsPerProfessionalInFieldUseCaseInterface,
  ExportNumberStudentsPerProfessionalInFieldUseCaseInterface,
} from 'domain/usecases';
import {
  makeApiUrlNumberStudentsPerProfessionalInField,
  makeApiUrlExportNumberStudentsPerProfessionalInField,
} from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetNumberStudentsPerProfessionalInField =
  (): GetNumberStudentsPerProfessionalInFieldUseCaseInterface =>
    new RemoteGetNumberStudentsPerProfessionalInField(
      makeApiUrlNumberStudentsPerProfessionalInField(),
      makeAxiosHttpClient(),
    );

export const makeExportNumberStudentsPerProfessionalInField =
  (): ExportNumberStudentsPerProfessionalInFieldUseCaseInterface =>
    new RemoteExportNumberStudentsPerProfessionalInField(
      makeApiUrlExportNumberStudentsPerProfessionalInField(),
      makeAxiosHttpClient(),
    );
